/**
 * @generated SignedSource<<c559a05c3a5ff7e6824dc99ce84d3bf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTeamRouteUpdateInstructionMutation$variables = {
  body: string;
  teamId?: any | null | undefined;
};
export type CreateTeamRouteUpdateInstructionMutation$data = {
  readonly updateInstruction: {
    readonly error: {
      readonly message: string;
    } | null | undefined;
    readonly success: {
      readonly instruction: {
        readonly body: string;
        readonly id: any;
      };
    } | null | undefined;
  };
};
export type CreateTeamRouteUpdateInstructionMutation = {
  response: CreateTeamRouteUpdateInstructionMutation$data;
  variables: CreateTeamRouteUpdateInstructionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "body"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "body",
        "variableName": "body"
      },
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      }
    ],
    "concreteType": "UpdateInstructionResponse",
    "kind": "LinkedField",
    "name": "updateInstruction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateInstructionSuccess",
        "kind": "LinkedField",
        "name": "success",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLInstruction",
            "kind": "LinkedField",
            "name": "instruction",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UpdateInstructionError",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTeamRouteUpdateInstructionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTeamRouteUpdateInstructionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f7170ce3e3eb921387b8ce0184de6b36",
    "id": null,
    "metadata": {},
    "name": "CreateTeamRouteUpdateInstructionMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTeamRouteUpdateInstructionMutation(\n  $body: String!\n  $teamId: GlobalID\n) {\n  updateInstruction(body: $body, teamId: $teamId) {\n    success {\n      instruction {\n        id\n        body\n      }\n    }\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c0f94b1f6ee600f0fbd8527d6948a9e";

export default node;
